//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import action from './action';
  import { yoButton } from 'components';

  export default {
    name: 'index',
    props: ['params'],
    metaInfo: {
      title: ''
    },
    created: async function() {
			// await this.test('TOAST');
			// console.log('-----------this created', this);
		},
		// async mounted() {
		// 	await this.test('TOAST');
		// 	console.log('-----------this mounted', this);
		// },
    data() {
      return {
				btns: [
					{name: 'CanIUse+(+代表完成)', func: 'CAN_I_USE'},
					{name: '状态栏+', func: 'SET_STATUS_BAR'},
					{name: '头部导航栏+', func: 'SET_HEADER'},
					{name: '键盘+', func: 'KEYBOARD'},
					{name: '剪切板+', func: 'CLIPBOARD'},
					{name: '硬件信息+', func: 'DEVICE_INFO'},
					{name: '震动+', func: 'VIBRATION'},
					{name: 'App信息+', func: 'APP_INFO'},
					{name: '相机+', func: 'CAMERA'},
					{name: '图片查看与下载+', func: 'IMAGE'},
					{name: 'APP运行状态+', func: 'APP_STATE'},

					{name: '购买+', func: 'BUY'},
					{name: '收藏+', func: 'ADD_TO_FAVORITE'},
					{name: '加入购物车+', func: 'ADD_TO_CART'},
					{name: '分享+', func: 'SET_SHARE'},
					{name: '导航+', func: 'NAVIGATION'},
					{name: '获取用户信息+', func: 'GET_USER_INFO'},
					{name: '获取商家信息+', func: 'GET_BUSINESS_INFO'},
					{name: 'Toast+', func: 'TOAST'},
					{name: 'Alert+', func: 'ALERT'},
					{name: 'Popup+', func: 'POPUP'},
				],
				RNToast: {}
      };
    },
    computed: {},
    components: {
      yoButton
    },
    methods: {
      ...action
    }
  };



// WEBPACK FOOTER //
// ./src/module/app/jsBridge/page.vue